import request from '@/utils/request';

/**
 * @description 字典数据列表
 */
export function listSimpleDictDatas() {
  return request({
    url: 'admin/platform/dict/list-all-simple',
    method: 'get'
  });
}